// Filename: HomeButton.tsx
//
// Component: HomeButton
//
// Purpose:
// Provide a compact icon-only button that displays a Home icon.
// This component wraps MUI's Button and applies custom styles via sx.
//
// What this file does:
// - Imports the Home icon from MUI icons.
// - Uses MUI Button as the base component.
// - Applies custom styling from useHomeButtonStyles.
// - Exposes an onClick prop so parent components can define behavior.

import { Home } from "@mui/icons-material"; // Home icon component
import { Button } from "@mui/material"; // MUI Button component
import { useHomeButtonStyles } from "./HomeButtonStyle"; // Custom style hook for this component

// HomeButtonProps
// Defines the props accepted by the HomeButton component.
interface HomeButtonProps {
  onClick: () => void; // Function to run when the button is clicked
}

// HomeButton component
// Renders an icon-only button styled as a small circular button.
const HomeButton = ({ onClick }: HomeButtonProps) => {
  // Fetch styles for this component from the style hook
  const {classes} = useHomeButtonStyles();

  return (
    // Render an MUI button using "text" variant and custom sx styles
    <Button className={classes.outerButton} variant="text" onClick={onClick}>
      {/* Render the home icon inside the button */}
      <Home />
    </Button>
  );
};

export default HomeButton;
